/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminRmaDeviceInspection { 
    rmaItemId: string;
    result: AdminRmaDeviceInspection.ResultEnum;
    failureReason?: string;
    testCompletedTimestamp?: string;
}
export namespace AdminRmaDeviceInspection {
    export const ResultEnum = {
        Passed: 'PASSED',
        Conditional: 'CONDITIONAL',
        Failed: 'FAILED'
    } as const;
    export type ResultEnum = typeof ResultEnum[keyof typeof ResultEnum];
}


export type ResultEnum = typeof AdminRmaDeviceInspection.ResultEnum[keyof typeof AdminRmaDeviceInspection.ResultEnum];
